export const getFileExtension = (fileName: string) =>
    fileName.substring(fileName.lastIndexOf("."), fileName.length).toLowerCase()

export const getUniqueFileExtensions = (files: File[]) => {
    // check that all files have the same ext.
    const allFileExtensionsSet = new Set<string>()
    files.forEach((file) => {
        const ext = getFileExtension(file.name)
        if (ext && !allFileExtensionsSet.has(ext)) {
            allFileExtensionsSet.add(ext)
        }
    })

    return [...allFileExtensionsSet.keys()]
}
